@if (rows.length) {
  <table class="quote-table">
    <thead>
      <tr>
        <th>{{ 'quotes.field.number' | translate }}</th>
        @if (showOrganisation) { <th>{{ 'quotes.field.organisation' | translate }}</th> }
        <th>{{ 'quotes.field.title' | translate }}</th>
        <th>{{ 'quotes.field.responsible' | translate }}</th>
        <th>{{ 'quotes.field.quote_date' | translate }}</th>
        <th>{{ 'quotes.field.expires_on' | translate }}</th>
        <th>{{ 'quotes.field.status' | translate }}</th>
        @if (actions) { <th><span class="sr-only">{{ 'quotes.actions' | translate }}</span></th> }
      </tr>
    </thead>
    <tbody>
      @for (q of rows; track q.id) {
        <tr>
          <td class="number"><a [routerLink]="['/quotes', q.id]" (click)="opened.emit(q)">{{ q.number }}</a> <span class="muted">{{ 'quotes.version' | translate:{n: q.version} }}</span></td>
          @if (showOrganisation) { <td class="org" [title]="q.organisation.name ?? ''">{{ q.organisation.name }}</td> }
          <td class="title" [title]="q.title">{{ q.title }}</td>
          <td class="responsible">@if (q.responsible) { {{ q.responsible.name }} } @else { <span class="muted">–</span> }</td>
          <td class="date">{{ q.quote_date | localedate:'D MMM YYYY' }}</td>
          <td class="date expires">{{ q.expires_on | localedate:'D MMM YYYY' }}</td>
          <td class="status"><bst-quote-status [status]="q.status"></bst-quote-status></td>
          @if (actions) {
            <td class="actions">
              <button nbButton ghost size="tiny" type="button" class="download" [attr.aria-label]="('quotes.download' | translate) + ' ' + q.number"
                      [disabled]="!q.printable" [title]="q.printable ? '' : ('quotes.pdf_open_first' | translate)" (click)="download.emit(q)">
                <nb-icon icon="download-outline"></nb-icon>
              </button>
              @if (q.deletable) {
                <button nbButton ghost size="tiny" status="danger" type="button" class="delete" [attr.aria-label]="('quotes.delete' | translate) + ' ' + q.number" (click)="remove.emit(q)">
                  <nb-icon icon="trash-2-outline"></nb-icon>
                </button>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
} @else {
  <p class="empty">{{ 'quotes.none_yet' | translate }}</p>
}
